module.exports = __webpack_public_path__ + "static/media/dots9.d26dd4f8.png";